import Constants from '../config/constants';

const TOKEN_TIMEOUT = 60000;
let scriptPromise = null;

function loadTurnstile() {
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => {
                scriptPromise = null;
                reject(new Error('Turnstile failed to load'));
            };
            document.head.appendChild(script);
        });
    }
    return scriptPromise;
}

// Returns a Cloudflare Turnstile token for the given action, or null when Turnstile is not configured or unavailable.
// The widget stays hidden unless Cloudflare needs the user to interact with it.
export async function getTurnstileToken(action) {
    if (!Constants.TURNSTILE_SITE_KEY) {
        return null;
    }
    let container = null;
    let widgetId = null;
    try {
        await loadTurnstile();
        container = document.createElement('div');
        container.style.cssText = 'position:fixed;bottom:16px;right:16px;z-index:2000;';
        document.body.appendChild(container);
        return await new Promise((resolve) => {
            const timer = setTimeout(() => resolve(null), TOKEN_TIMEOUT);
            const finish = (token) => {
                clearTimeout(timer);
                resolve(token);
            };
            widgetId = window.turnstile.render(container, {
                sitekey: Constants.TURNSTILE_SITE_KEY,
                action,
                appearance: 'interaction-only',
                callback: (token) => finish(token),
                'error-callback': () => finish(null),
                'timeout-callback': () => finish(null),
            });
        });
    } catch (e) {
        return null;
    } finally {
        if (widgetId !== null && window.turnstile) {
            window.turnstile.remove(widgetId);
        }
        if (container) {
            container.remove();
        }
    }
}
